import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck, Globe } from 'lucide-react';
import { Button } from './ui/Button';
import { CountdownTimer } from './ui/CountdownTimer';
import { buildCheckoutUrl } from '../utils/checkout';
export function SpecialOffer() {
  return <section id="offer" className="py-24 bg-navy-900 relative overflow-hidden" data-id="element-180" data-mp="u1getkhh4lrs">
      <div className="absolute inset-0 bg-stadium-glow opacity-80 pointer-events-none" data-id="element-181" data-mp="tzdh0ea2xoci"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-182" data-mp="f6jx8gnrym21">
        <div className="max-w-4xl mx-auto" data-id="element-183" data-mp="k4brhhbw6k9e">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-12" data-id="element-184" data-mp="k163y6iwvqfs">
            <div className="inline-block bg-red-600 text-white font-oswald uppercase tracking-widest px-4 py-1 rounded-full text-sm mb-6 animate-pulse" data-id="element-185" data-mp="25gliaqpfiocg">
              Offre de Lancement
            </div>
            <h2 className="font-anton text-5xl md:text-6xl text-white uppercase tracking-wide mb-4" data-id="element-186" data-mp="2pugkkb192d16">
              OFFRE SPÉCIALE
            </h2>
            <h3 className="font-oswald text-2xl md:text-3xl text-gold-500 uppercase tracking-widest" data-id="element-187" data-mp="33l3iw233m0wq">
              LE SYSTÈME COMPLET EN 6 VOLUMES
            </h3>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-navy-950 border-2 border-gold-500/50 rounded-2xl p-6 md:p-12 shadow-[0_0_50px_rgba(242,193,78,0.15)] relative" data-id="element-188" data-mp="2axpghogmsd58">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-navy-950 border-2 border-gold-500/50 px-6 py-2 rounded-full" data-id="element-189" data-mp="31tif1l87it">
              <span className="font-anton text-xl text-gold-500 tracking-wider" data-id="element-190" data-mp="37985mir4x1b">
-72%
              </span>
            </div>

            <div className="mb-10" data-id="element-191" data-mp="76rqcaj6uu0g">
              <img src="https://cdn.magicpatterns.com/uploads/ocV3WBeEd7LgfDra6igomR/M_-_1.webp" alt="Aperçu du Système 365" width={1536} height={1024} loading="lazy" decoding="async" style={{
              aspectRatio: '1536 / 1024'
            }} className="block w-full max-w-2xl mx-auto h-auto rounded-xl shadow-2xl" data-id="element-192" data-mp="79xk432rik2i" />
            </div>

            <div className="text-center mb-10" data-id="element-193" data-mp="3pjzeq0ldnly7">
              <div className="text-gray-400 font-oswald text-xl line-through mb-2" data-id="element-194" data-mp="3ud27w7m8stdv">
                Prix Normal : 97 USD
              </div>
              <div className="text-gold-500 font-oswald text-2xl uppercase tracking-widest mb-2" data-id="element-195" data-mp="2wx4y5erol6q0">
                Aujourd'hui Seulement :
              </div>
              <div className="font-anton text-7xl md:text-8xl text-white tracking-wider mb-4 drop-shadow-lg" data-id="element-196" data-mp="2ud8gokowl5ae">
                23 USD
              </div>
              <p className="inline-flex items-center gap-2 text-gold-400 text-sm font-medium" data-id="element-197" data-mp="2pc1cevlyyo8h">
                <Globe className="w-4 h-4" data-id="element-198" data-mp="2kgvo5q53gxh8" />
                Payez en toute sécurité dans votre devise locale.
              </p>
            </div>

            <div className="bg-navy-900 border border-navy-700 rounded-xl p-6 mb-10" data-id="element-199" data-mp="2beco1dsp0yyo">
              <div className="text-center mb-6" data-id="element-200" data-mp="26mungqul10e8">
                <span className="text-red-400 font-bold flex items-center justify-center gap-2" data-id="element-201" data-mp="26m35wjxtl36y">
                  <span className="animate-pulse" data-id="element-202" data-mp="21okrie119vrk">🔥</span>
                  Dernière Chance ! Ce prix augmente quand le compte à rebours
                  arrive à zéro.
                </span>
              </div>
              <CountdownTimer data-id="element-203" data-mp="1rs7y7h9ehjxc" />
            </div>

            <div className="flex flex-col items-center gap-6" data-id="element-204" data-mp="1noa45kyxmzb5">
              <Button size="xl" fullWidth className="max-w-2xl" onClick={() => {
              ;
              (window as any).fbq?.('track', 'InitiateCheckout', {
                value: 23,
                currency: 'USD'
              });
              window.location.href = buildCheckoutUrl();
            }} data-id="element-205" data-mp="2cf67wl8yib73">
OUI, JE VEUX LE SYSTÈME COMPLET (23 USD)
              </Button>

              <div className="flex flex-col items-center gap-3" data-id="element-206" data-mp="1tndewqtw0pzd">
                <div className="flex items-center gap-1" data-id="element-207" data-mp="1yo1ei0w6mf57">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold-500 text-gold-500" data-id="element-208" data-mp="1kp1oopwxnu7g" data-mpi={i} />)}
                  <span className="ml-2 font-oswald text-lg text-gray-200" data-id="element-209" data-mp="3f2auo7q9sxky">
                    4.9/5 — Avis Vérifiés
                  </span>
                </div>

                <div className="flex items-center gap-2 text-gray-400 text-sm font-medium" data-id="element-210" data-mp="3j1ij432mqxwk">
                  <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-211" data-mp="17gj2t4sf4u2x" />
                  <span data-id="element-212" data-mp="13fpeiab2dd9i">
                    Garantie Satisfait ou Remboursé 7 Jours — Zéro Risque
                  </span>
                </div>

                <div className="flex items-center gap-2 text-gray-400 text-sm font-medium" data-id="element-213" data-mp="1h7xahzuix075">
                  <Globe className="w-4 h-4 text-gold-500" data-id="element-214" data-mp="1cd9j9t84xrov" />
                  <span data-id="element-215" data-mp="1r3788bdw2lf4">Payez Dans Votre Devise Locale</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}